import React from "react";
import {useEffect,useState} from "react";
import { Link, json } from "react-router-dom";
import './AssetCard.css';
var FontAwesome = require('react-fontawesome');

function AssetCard(props,value) {
    // const [propvalue,setpropvalue] = useState();
    let propvalue = [];
    let newArr = [];
    let globalPdfArray = [];
    let image_link = ""
    // let value = "";
    console.log("inAssetCard",props);
    console.log("imglink", props.image_link);
    if(props.image_link == null)
    {
        image_link = null
    }else{
        image_link = props.image_link
    }
    console.log("newimage_link",image_link);
    newArr.push(props.image_link);
    console.log("newArr",newArr);

    // Filter out undefined values from newArr
    newArr = newArr.filter(value => value !== undefined);
    console.log("newArr (after filtering)", newArr);

    // Filter out elements that do not have a .pdf extension
   newArr = newArr.filter(link => link && link.toLowerCase().endsWith('.pdf'));
   console.log("newArr (after filtering2)", newArr);

   // Assign the filtered array to the global variable
   globalPdfArray = newArr;

   console.log("globalPdfArray", globalPdfArray); // Now globalPdfArray contains the filtered links with .pdf extensions



    // const imageLinks = props.image_link;
    // const pdfLinks = imageLinks.filter(link => link.toLowerCase().endsWith('.pdf'));
    // console.log("pdfLinks",pdfLinks);

    



    const handleCheckboxChange = async (event) => {
        console.log("in function")
        console.log("props",props);
        propvalue.push(props);
        value = propvalue[0];
        console.log("propvalue",propvalue);
        console.log("value",value);
        console.log("event",event);
        // return props;
    }

    return (
        <div className="card mb-5 product-card">
            {/* <img src={require("../images/Olive_Oil.jpg")} className="card-img-top img-card" alt="nft" /> */}
            {props?.assetType === "NonEprAsset" ? (
                // If assetType is "NonEprAsset"
                props.image_link && !props.image_link.toLowerCase().endsWith('.pdf') ? (
                    // If image_link is not blank, display the image
                    <img src={props.image_link} className="card-img-top img-card" alt="nft" />
                ) : (
                    // If image_link is blank, display a default image
                    <div className="card-img-top img-card noneprimageassetcard"/>
                )
                )
            :
            (
                // Logic commented for user uploded image and default credit image 

                // image_link == "null" ||  image_link == "" || image_link == null || image_link == undefined || image_link.toLowerCase().endsWith('.pdf')? (
                //         // If image_link is blank or null, display default content
                //         <div className="eprimagecard card-img-top img-card">
                //             <div alt="nft" style={{fontSize: "17px"}}>{"Plastic Credit"}</div>
                //             <div alt="nft" style={{fontSize: "17px"}}>{props?.totalcopy} {props?.UOM}</div>
                //         </div>
                   
                //     ) : (
                         
                //     // If image_link is not blank and not null, display the image
                //     <img src={"https://s3-ap-south-1.amazonaws.com/tracechain/transactions/static-media/"+props.image_link} className="card-img-top img-card" alt="nft" />
                //     )
               // Logic commented for user uploded image and default credit image

                <div className="eprimagecard card-img-top img-card">
                    <div alt="nft" className="epr-card-text">{"Plastic Credit"}</div>
                    <div alt="nft" className="epr-card-text-MT ">{props?.totalcopy} {props?.UOM}
                    </div>
                </div>

            )
            }

            <div className="card-body" style = {{marginTop:'1px'}}>
            {
            (props?.price == null) ?
            (
             <p  className="card-text" style={{ fontSize: '13px', marginTop:'1px'}}> Product Price - 0 USD</p>
             ) :
             (
            <p  className="card-text" style={{ fontSize: '13px',marginTop:'1px' }}> Product Price - {props.price} USD</p>
             )
            }
            {/* <p className="fs-4 fw-bold">${props.price}  */}
                {/* {props.network_type == "algorand" ? 
                   (
                    <span> ALGO</span>
                    ) : 
                    // (
                    //   <span> MATIC</span>
                    // )
                }{" "} */}
                {/* </p>                 */}
                {/* <p className="card-text" style={{ fontSize: '15px', marginTop:'1px' }}>Supplier - {props.ownerName}</p> */}
                <p className="card-text" style={{ fontSize: '13px', marginTop:'1px' }}>Supplier - {props.ownerName}</p>
                <p className="card-text" style={{ fontSize: '13px', marginTop:'1px' }}>Product Name - {props.name}</p>
                <p className="card-text" style={{ fontSize: '13px', marginTop:'1px' }}>Product ID - {props.assetId}</p>
                <p className="card-text" style={{ fontSize: '13px', marginTop:'1px' }}>Platform - {props.network_type}</p>
                {/* <Link to={{ pathname: `/details/${id}`, state: { name, description } }}> */}
                {/* {value} */}
                {/* <Link to={`/details/${id}?name=${name}&description=${description}`}></Link> */}
                <Link to={`/asset/${props.token_id}/${props.assetType}?owner=${props.owner}&assetType=${props.assetType}&TokenId=${props.token_id}`}>
                    
                    <button className="assetbuttoncard" 
                    onClick={() => handleCheckboxChange()}
                    >BUY NOW</button>
                </Link>
            </div>
        </div>
    )
}

export default AssetCard;